export default "__VITE_ASSET__92c473be__"